import { createValidate } from 'typia'
import { validateGuard } from 'components/shared/parsing/parsing.js'

export type IQuotationPriceUOMDTO = {
  name: string
  symbol: string
  price: string
}

export class QuotationPriceUOMDTO {
  name: string
  symbol: string
  price: string

  constructor(data: IQuotationPriceUOMDTO) {
    this.name = data.name
    this.symbol = data.symbol
    this.price = data.price
  }
}

const validate = createValidate<IQuotationPriceUOMDTO>()

export const parseQuotationPriceUOMDTO = (data: unknown) => {
  validateGuard(validate, data, 'quotation price UOM')
  return new QuotationPriceUOMDTO(data)
}
